import './App.css'
import React from "react";
import {useAuth0} from '@auth0/auth0-react';
import {useProfile} from "../UserProfileProvider";
import {Link, useNavigate} from "react-router-dom";
import {ActionButton} from "../util/UI/ActionButton";
import {useAuthUtil} from "../util/AuthUtil";

export const Header = () => {

  const {user, isLoading} = useAuth0();
  const {profile, profileLoading} = useProfile();
  const {auth0Login} = useAuthUtil();

  const navigate = useNavigate();
  const host = window.location.host

  return (
      <div className={'AppSection BeigeSection WaitlistHeader'}>
        <div className={'AppSectionContent Flex1'}>

          <div className={'Header'}>
            <div className={'HeaderLeftElement'}>
              <Link style={{display: 'flex', justifyContent: 'left'}} to={'/'}>
                <img alt={'Kensu Logo'} src={require('../images/kensulogo.png')}
                     className={'HeaderLogo DarkModeInvert'}/>
              </Link>
              {host.startsWith("localhost") && <span style={{color: 'var(--green)'}}>local&nbsp;</span>}
              {host.endsWith("thymebook.com") && <span style={{color: 'var(--red)'}}>dev&nbsp;</span>}
            </div>

            <div className={'HeaderRightElement'}>
              {!user && !isLoading && <ActionButton onClick={() => auth0Login('/home')}>LOGIN</ActionButton>}
              {user && !profile && !profileLoading  && <ActionButton onClick={() => navigate('/home')}>JOIN KENSU</ActionButton>}
              {user && profile && <Link to={'/home'}><img className={'ProfileButton DarkModeInvert'} src={require('../images/icons/profile.png')}/></Link>}
            </div>
            
          </div>
        </div>
      </div>
  );
} 